// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3adDt","log":"ModalInventoryLogs_log__22nYa","date":"ModalInventoryLogs_date__2Fu8k","userName":"ModalInventoryLogs_userName__3Iij9"};